import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { fmt } from "../../lib/api";
import SectionCard from "./SectionCard";
import {
  Select, SelectTrigger, SelectContent, SelectItem, SelectValue,
} from "../ui/select";

const AYLAR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
               "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export default function Kategori2({ factors, data, setData, results }) {
  const setKaynak = (v) => setData((d) => ({ ...d, kaynak_id: v }));
  const setYillik = (v) => setData((d) => ({ ...d, elektrik_yillik: v }));
  const setAylik = (ay, v) => setData((d) => ({ ...d, elektrik_aylik: { ...(d.elektrik_aylik || {}), [ay]: v } }));

  const kaynak = factors.elektrik.find((k) => k.id === data.kaynak_id) || factors.elektrik[0];

  return (
    <div className="space-y-6 animate-fadeInUp">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Kategori 2</div>
        <h2 className="font-display text-3xl font-semibold">İthal Enerji · Elektrik Tüketimi</h2>
        <p className="text-muted-foreground mt-1 text-sm max-w-2xl">
          Şebekeden satın alınan elektrik tüketiminden kaynaklanan dolaylı emisyonlar.
        </p>
      </div>

      <SectionCard title="Elektrik Kaynağı" total={results?.total}>
        <div className="grid md:grid-cols-2 gap-4 mb-5">
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Elektrik Şebekesi</Label>
            <Select value={data.kaynak_id} onValueChange={setKaynak}>
              <SelectTrigger data-testid="k2-kaynak-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {factors.elektrik.map((k) => (
                  <SelectItem key={k.id} value={k.id}>{k.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <div className="text-[11px] text-muted-foreground mt-1.5">
              EF: {fmt(kaynak.ef, 4)} kg CO₂e/kWh · {kaynak.kaynak}
            </div>
          </div>
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Yıllık Toplam (kWh)</Label>
            <Input type="number" step="any" value={data.elektrik_yillik || ""}
                   onChange={(e) => setYillik(e.target.value)}
                   placeholder="Ör: 11368.21" data-testid="k2-yillik" />
            <div className="text-[11px] text-muted-foreground mt-1.5">
              Aylık değer girerseniz, yıllık toplam otomatik üzerine yazılır.
            </div>
          </div>
        </div>

        <div>
          <Label className="text-sm font-medium mb-3 block">Aylık Tüketim (İsteğe bağlı detay)</Label>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {AYLAR.map((ay) => (
              <div key={ay}>
                <div className="text-[11px] text-muted-foreground mb-1">{ay}</div>
                <Input type="number" step="any" value={data.elektrik_aylik?.[ay] || ""}
                       onChange={(e) => setAylik(ay, e.target.value)}
                       placeholder="kWh" className="h-9" data-testid={`k2-ay-${ay}`} />
              </div>
            ))}
          </div>
          <div className="text-xs text-muted-foreground mt-3 flex justify-between">
            <span>Aylık toplam: <strong className="text-foreground">{fmt(results?.aylik_toplam || 0, 0)} kWh</strong></span>
            <span>Kullanılan: <strong className="text-foreground">{fmt(results?.kwh || 0, 0)} kWh</strong></span>
          </div>
        </div>
      </SectionCard>
    </div>
  );
}
